import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import IPhoneMockup from '../ui/IPhoneMockup'
import heroShapeDark from '../../../assets/images/doctor-legal/hero-shape-dark.png'
import heroShapeBlue from '../../../assets/images/doctor-legal/hero-shape-blue.png'
import heroVideo from '../../../assets/videos/app.mp4'

const ctaVariant = {
  hidden: { opacity: 0, y: 15, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6, ease: 'easeOut' },
  },
}

const itemVariant = {
  hidden: { opacity: 0, y: 15, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6, ease: 'easeOut' },
  },
}

function CTAButtons({ className = '' }) {
  return (
    <div className={`flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto ${className}`}>
      <a href="#planos" className="btn-primary w-full sm:w-auto group">
        Conhecer a plataforma
        <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
      </a>
      <a href="#como-funciona" className="btn-secondary w-full sm:w-auto">
        Como funciona
      </a>
    </div>
  )
}

export default function Hero() {
  return (
    <section className="relative w-full min-h-[90vh] flex items-center bg-surface-page pt-28 pb-16 md:py-24 overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-6 w-full flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-8 z-10">
        <motion.div
          className="w-full lg:w-1/2 flex flex-col items-start text-left gap-5 lg:gap-8 order-1"
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: { staggerChildren: 0.1, delayChildren: 0.2 },
            },
          }}
        >
          <motion.div
            className="bg-white border border-border-default shadow-sm rounded-full px-4 py-2 inline-flex"
            initial={{ opacity: 0, y: 15, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
          >
            <span className="text-[10px] font-extrabold uppercase tracking-wider bg-gradient-to-r from-accent-primary to-[#00C6FF] bg-clip-text text-transparent">
              Para médicos, por advogados especialistas
            </span>
          </motion.div>

          <motion.h1
            className="text-[38px] sm:text-[48px] md:text-[64px] lg:text-[72px] font-extrabold tracking-tight leading-[0.95] text-text-primary"
            variants={itemVariant}
          >
            A proteção jurídica
            <br />
            que a faculdade
            <br />
            <span className="text-accent-primary">não te deu.</span>
          </motion.h1>

          <motion.p
            className="text-base md:text-[20px] text-text-secondary leading-relaxed max-w-lg"
            variants={itemVariant}
          >
            A única plataforma que traduz o direito para a linguagem clínica.
            Defesa médica preventiva feita por quem entende sua rotina real.
          </motion.p>

          <motion.div variants={ctaVariant} className="hidden lg:block pt-4">
            <CTAButtons />
          </motion.div>
        </motion.div>

        <div className="w-full lg:w-1/2 flex items-center justify-center my-10 lg:my-15 order-2">
          <div className="relative w-[180px] sm:w-[220px] md:w-[260px] lg:w-[280px] flex justify-center items-center">
            <img
              src={heroShapeDark}
              alt=""
              aria-hidden="true"
              className="absolute pointer-events-none select-none"
              style={{
                zIndex: 0,
                right: '-35%',
                top: '-5%',
                width: '100%',
                maxWidth: '380px',
                height: 'auto',
              }}
            />
            <img
              src={heroShapeBlue}
              alt=""
              aria-hidden="true"
              className="absolute pointer-events-none select-none"
              style={{
                zIndex: 1,
                left: '-25%',
                bottom: '-5%',
                width: '100%',
                maxWidth: '380px',
                height: 'auto',
              }}
            />
            <div className="relative z-10 w-full">
              <IPhoneMockup videoSrc={heroVideo} />
            </div>
          </div>
        </div>

        <motion.div
          className="w-full lg:hidden order-3"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut', delay: 0.4 }}
        >
          <CTAButtons />
        </motion.div>
      </div>
    </section>
  )
}
